const storageProperty = "hwid";
export default () => ({
    token: null,
    passTokenToLivewire(){
        // console.log( "passTokenToLivewire" );
        if ( !!window.Livewire ) {
            // console.log( "window.Livewire", window.Livewire );
            this.$wire.moveHWIDStorageToCookie( this.token ).then( result => {
                // console.log( "moveHWIDStorageToCookie has run" );
                // this is a good place to unset the `localStorage` property/value
                window.localStorage.removeItem( storageProperty );
            } );
        }
    },
    getToken(){
        // console.log( 'getToken', window.localStorage );
        return window.localStorage[ storageProperty ] ?? null;
    },
    init() {
        // console.log( 'LegacyHWID', { this: this, "$wire": this.$wire } );
        this.token = this.getToken();
        if ( !!this.token ) {
            this.passTokenToLivewire();
        }
    }
});
